// @flow
import * as React from 'react';
import {useDiagramGenerator} from 'docs/data';
import {AddEntityNode} from './AddEntityNode';
import {AddOverviewNode} from './AddOverviewNode';
import {AddStateNode} from './AddStateNode';
import {AddSequenceNode} from './AddSequenceNode';

export const AddNode = () => {
  const {type} = useDiagramGenerator();
  switch (type) {
    case 'overview':
      return <AddOverviewNode />;
    case 'entity':
      return <AddEntityNode />;
    case 'state':
      return <AddStateNode />;
    case 'sequence':
      return <AddSequenceNode />;
    default:
      return null;
  }
};
